import React from "react";
import injectSheet from "react-jss";
import { useTranslation } from "react-i18next";
import { Step, ButtonResponsive } from "folksam-ui";
import themeOverride from "./themeOverride";
import { ThemeProvider } from "react-jss";
const style = ({ theme }) => ({
  root: {
    "& Footer": {
      paddingLeft: 0
    }
    // margin: [0, "-18px"],
    // [`@media (min-width: ${theme.screens.md}px)`]: {
    //   margin: [0, "-24px"]
    // },
    // [`@media (min-width: ${theme.screens.lg}px)`]: {
    //   margin: [0, "-48px"]
    // }
  }
});

const FormStepFooter = ({ classes }) => {
  const { t } = useTranslation();
  return (
    <div className={classes.root}>
      <ThemeProvider theme={{ theme: themeOverride }}>
        <Step.Footer>
          <ButtonResponsive type={"submit"} primary>
            {t("step.general.next.label")}
          </ButtonResponsive>
        </Step.Footer>
      </ThemeProvider>
    </div>
  );
};

export default injectSheet(style)(FormStepFooter);
